import React from 'react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { HighlightQuote } from '../ui/HighlightQuote';
import { CtaButton } from '../ui/CtaButton';
import { images } from '../../data/images';
export function TransformationSection() {
  return <Section id="mi-transformacion" tone="ink" data-id="element-259" data-mp="3mwvuprm2s9js">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-260" data-mp="3mxov8aufy2th">
        <figure className="lg:col-span-6" data-id="element-261" data-mp="eix1uyueh4ai">
          <div className="relative overflow-hidden rounded-lg border border-brand/60 shadow-[0_0_48px_rgba(229,9,20,0.22)]" data-id="element-262" data-mp="efsmd5bhim4j">
            <img src={images.coachTransformation} alt="Antes y después de Sebastian Vargas: a la izquierda más delgado y sin definición, a la derecha con más músculo y definición" className="aspect-square w-full object-cover" data-id="element-263" data-mp="5hgrus7hz46t" />
            <div className="absolute inset-y-0 left-1/2 w-0.5 -translate-x-1/2 bg-brand" aria-hidden="true" data-id="element-264" data-mp="2u8rl4v0dvcbt" />
            <span className="absolute left-3 top-3 rounded-sm bg-ink/85 px-3 py-1 font-display text-sm font-bold uppercase tracking-[0.15em] text-white sm:left-4 sm:top-4" data-id="element-265" data-mp="2h5521rshvuml">
              Antes
            </span>
            <span className="absolute right-3 top-3 rounded-sm bg-brand px-3 py-1 font-display text-sm font-bold uppercase tracking-[0.15em] text-white sm:right-4 sm:top-4" data-id="element-266" data-mp="2q6bhrynbl1es">
              Después
            </span>
          </div>
        </figure>

        <div className="lg:col-span-6" data-id="element-267" data-mp="30265h86ehmof">
          <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-brand sm:text-sm" data-id="element-268" data-mp="2v5o3gg2gg2fs">
            <span className="h-0.5 w-8 bg-brand" aria-hidden="true" data-id="element-269" data-mp="39t0toi37iwci" />
            Mi transformación
          </p>
          <SectionTitle className="mt-6" data-id="element-270" data-mp="34wagc2iseeus">
            Yo también tuve que <Accent data-id="element-271" data-mp="3iu7bcuhled7c">dejar de improvisar.</Accent>
          </SectionTitle>
          <p className="mt-6 text-lg leading-relaxed text-white" data-id="element-272" data-mp="3ise1z7flhevn">
            Antes de guiar a otros, tuve que pasar por mi propio proceso. Mi cambio físico no vino de una dieta extrema
            ni de motivación perfecta. Vino de aprender a entrenar con dirección, comer con estrategia y construir
            disciplina paso a paso.
          </p>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-muted" data-id="element-273" data-mp="2khuyqqbdumxx">
            <p data-id="element-274" data-mp="2pa5xhpue02ow">
              Por eso entiendo cuando alguien llega frustrado, confundido o cansado de empezar otra vez. Sé lo que se
              siente querer cambiar, pero no tener claridad sobre qué hacer primero.
            </p>
            <p data-id="element-275" data-mp="2z692r4kjchg2">
              Hoy mi trabajo es ayudarte a evitar esa confusión y darte una ruta más clara para perder grasa, ganar
              músculo y transformar tu cuerpo con estructura.
            </p>
          </div>

          <HighlightQuote className="mt-10" data-id="element-276" data-mp="3865wvlpp28ii">
            No te hablo desde la teoría. <span className="text-brand" data-id="element-277" data-mp="19ugr0zf6g2a6">Te hablo desde la experiencia.</span>
          </HighlightQuote>

          <div className="mt-10 flex flex-col items-start gap-4" data-id="element-278" data-mp="1dur3muxh5qy0">
            <CtaButton className="w-full sm:w-auto" data-id="element-279" data-mp="16bzzuoxititj" />
            <p className="max-w-md text-xs leading-relaxed text-muted" data-id="element-280" data-mp="16ct1jbhmhi4t">
              Los resultados pueden variar según el punto de partida, constancia, estilo de vida y adherencia al
              proceso.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}